import React, { useState } from 'react';
import { XIcon, CalendarIcon } from 'lucide-react';
import { AnyContact } from '../types';
interface ScheduleFollowUpModalProps {
  contact: AnyContact | null;
  isVisible: boolean;
  onClose: () => void;
  onSave: (contactId: string, date: string) => void;
}
export function ScheduleFollowUpModal({
  contact,
  isVisible,
  onClose,
  onSave
}: ScheduleFollowUpModalProps) {
  const [date, setDate] = useState('');
  if (!isVisible || !contact) return null;
  const handleSave = () => {
    if (date) {
      onSave(contact.id, date);
      setDate('');
    }
  };
  return <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-id="element-192">
      <div className="bg-olympian-surface border border-olympian-border rounded-xl shadow-2xl w-full max-w-md overflow-hidden animate-crossfade" data-id="element-193">
        <div className="px-6 py-4 border-b border-olympian-border flex justify-between items-center bg-olympian-navy/50" data-id="element-194">
          <h2 className="text-sm font-bold text-theme uppercase tracking-wider" data-id="element-195">
            Schedule Follow-up
          </h2>
          <button onClick={onClose} className="text-olympian-textMuted hover:text-theme transition-colors" data-id="element-196">
            <XIcon className="w-5 h-5" data-id="element-197" />
          </button>
        </div>

        <div className="p-6" data-id="element-198">
          <div className="mb-6 bg-olympian-navy p-3 rounded-lg border border-olympian-border" data-id="element-199">
            <p className="text-xs text-olympian-textMuted mb-1 uppercase tracking-wider font-bold" data-id="element-200">
              Contact
            </p>
            <p className="font-medium text-theme" data-id="element-201">
              {contact.name}{' '}
              <span className="text-olympian-textMuted font-mono ml-2 text-sm" data-id="element-202">
                {contact.phone}
              </span>
            </p>
          </div>

          <div className="mb-8" data-id="element-203">
            <label className="block text-xs font-bold text-olympian-textMuted uppercase tracking-wider mb-2" data-id="element-204">
              Follow-up Date
            </label>
            <div className="relative" data-id="element-205">
              <CalendarIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-olympian-textMuted" data-id="element-206" />
              <input type="date" value={date} onChange={e => setDate(e.target.value)} className="w-full pl-10 pr-3 py-2.5 bg-olympian-navy border border-olympian-border rounded-lg text-sm text-theme focus:ring-1 focus:ring-olympian-gold focus:border-olympian-gold outline-none [color-scheme:dark]" data-id="element-207" />
            </div>
          </div>

          <div className="flex justify-end gap-3" data-id="element-208">
            <button onClick={onClose} className="px-5 py-2.5 text-sm font-medium text-theme bg-olympian-navy hover:bg-olympian-navyLight border border-olympian-border rounded-lg transition-colors" data-id="element-209">
              Cancel
            </button>
            <button onClick={handleSave} disabled={!date} className="px-5 py-2.5 text-sm font-bold text-olympian-navy bg-olympian-gold hover:bg-olympian-goldHover rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-210">
              Save & Snooze
            </button>
          </div>
        </div>
      </div>
    </div>;
}